import { Box, Typography } from "@mui/material";
import BackToListButton from "molecules/BackToListButton";
import { ReactNode } from "react";
import { useResourceContext, useTranslate } from "react-admin";

type ListTitlePropsType = {
  label?: string | ReactNode;
  backButtonResource?: string;
};

export default function ListTitle(props: ListTitlePropsType) {
  const { label, backButtonResource } = props;
  const translate = useTranslate();
  const resource = useResourceContext();

  const finalLabel = label ? label : resource ? translate(`resources.${resource}.name`, 2) : "";

  return (
    <Box mb={2} display="flex">
      {backButtonResource && (
        <Box display="inline" marginRight={2}>
          <BackToListButton resource={backButtonResource} />
        </Box>
      )}
      <Typography variant="h5" fontWeight="700">
        {finalLabel}
      </Typography>
    </Box>
  );
}
